import { getReportAnalyticsEvent } from '@ms/yammer-data/dist/telemetry';
import { TelemetryContextProvider } from '@ms/yammer-web-support/dist/telemetry';
import React, { FC } from 'react';

const telemetryContextProviderValue = {
  getReportAnalyticsEvent,
};

const ReduxTelemetryContextProvider: FC = ({ children }) => (
  <TelemetryContextProvider value={telemetryContextProviderValue}>{children}</TelemetryContextProvider>
);

export default ReduxTelemetryContextProvider;
